'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { urlResolverGetLogin } from '../../url-handling'
import { loginRegistrationGtmPushFullStoryPayLoad } from '../gtm/events/loginRegistrationGtmPushFullStoryPayLoad'

export const useLoginRegistrationGtmPushFullStoryTracking = (
  isModalOpen: boolean,
): void => {
  const pathName = usePathname()
  const config = useGlobalConfigContext()

  useEffect(() => {
    const isRegister = window.location.hash === '#register'
    const onLoginRoute = pathName === urlResolverGetLogin(config)
    if (isRegister || (!isModalOpen && !onLoginRoute)) {
      return
    }

    loginRegistrationGtmPushFullStoryPayLoad({
      config,
      isModalOpen,
      pathName,
    })
  }, [config, isModalOpen, pathName])
}
